import React, {Fragment} from 'react';
import { List, Datagrid, Filter, TextField, TextInput, SelectField, ReferenceField, BulkDeleteWithConfirmButton } from 'react-admin';
import {
  EditButtonWithAuthStatus,
  DownloadFileContentButton, DateTimeField,
} from "../../components";

const BankStatementFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

const BulkActionButtons = props => {
  return <Fragment>
    <BulkDeleteWithConfirmButton {...props} />
  </Fragment>
};

export const BankStatementList = props => (
  <List filters={<BankStatementFilter />} {...props} exporter={false} bulkActionButtons={<BulkActionButtons />}>
    <Datagrid >
      <TextField source="id" />
      <TextField source="description" />
      <ReferenceField source="bankStatementTemplateId" reference="bankStatementTemplates" allowEmpty>
        <TextField source="name" />
      </ReferenceField>
      <SelectField source="authStatus" choices={[
        { id: 'DRAFT', name: 'Bản nháp' },
        { id: 'AUTHORIZED', name: 'Đã duyệt' },
      ]} />
      <DateTimeField source="authorizedDate" format="DD-MM-YYYY HH:mm" />
      <DownloadFileContentButton  />
      <EditButtonWithAuthStatus />
    </Datagrid>
</List>
);

export default BankStatementList
